module.exports = __webpack_public_path__ + "img/lnk-settings-footer.27693a89.svg";